import gql from "graphql-tag";

// fragment
export const GREENHOUSE_FRAGMENT = gql`
    fragment greenhouse on GreenhouseNode {
        id
        name
        description
        width
        height
        greenhouseDepartmentSet {
            edges {
                node {
                    id
                    name
                    description
                    temperatureMin
                    temperatureMax
                    humidityMin
                    humidityMax
                    pesticide
                    totalSpaceM2
                    totalUsedSpaceM2
                    totalUsedRate
                    isPlaceholder
                    layoutX
                    layoutY
                    width
                    height
                    order
                    isActive
                    greenhouseDepartmentSectionSet {
                        edges {
                            node {
                                id
                                name
                                spaceM2
                                usedSpaceM2
                                usedRate
                                numGrowthTasks
                                numPlants
                                order
                                isPlaceholder
                                layoutX
                                layoutY
                                width
                                height
                                isActive
                            }
                        }
                    }
                }
            }
        }
        updatedAt
        updatedBy
    }
`;

// all query
export const GREENHOUSES_QUERY = gql`
    query {
        greenhouses {
            edges {
                cursor
                node {
                    ...greenhouse
                }
            }
        }
    }
    ${GREENHOUSE_FRAGMENT}
`;

// singel query
export const SINGLE_GREENHOUSE_QUERY = gql`
    query greenhouse($id: ID!) {
        greenhouse(id: $id) {
            ...greenhouse
        }
    }
    ${GREENHOUSE_FRAGMENT}
`;

// create
export const CREATE_GREENHOUSE_MUTATION = gql`
    mutation createGreenhouse($input: CreateGreenhouseInput!) {
        createGreenhouse(input: $input) {
            greenhouse {
                ...greenhouse
            }
        }
    }
    ${GREENHOUSE_FRAGMENT}
`;

// update
export const UPDATE_GREENHOUSE_MUTATION = gql`
    mutation updateGreenhouse($input: UpdateGreenhouseInput!) {
        updateGreenhouse(input: $input) {
            greenhouse {
                ...greenhouse
            }
        }
    }
    ${GREENHOUSE_FRAGMENT}
`;

// delete
export const DELETE_GREENHOUSE_MUTATION = gql`
    mutation deleteGreenhouse($input: DeleteGreenhouseInput!) {
        deleteGreenhouse(input: $input) {
            greenhouse {
                ...greenhouse
            }
        }
    }
    ${GREENHOUSE_FRAGMENT}
`;

// update department laytous
export const UPDATE_GREENHOUSE_DEPARTMENT_LAYOUTS_MUTATION = gql`
    mutation updateGreenhouseDepartmentLayouts(
        $input: UpdateGreenhouseDepartmentLayoutsInput!
    ) {
        updateGreenhouseDepartmentLayouts(input: $input) {
            greenhouse {
                ...greenhouse
            }
        }
    }
    ${GREENHOUSE_FRAGMENT}
`;
